// extracted by mini-css-extract-plugin
export default {"discovered":"TargetLabels_discovered__H1zfq"};